const IllumioDomUtils = {
    removeChildren: function(element) {
        if (element && element.childElementCount>0) {
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
        }
    },
    createSimpleTextBlock: function(tagName, textContent, className) {
        var rootElement = null;
        
        if (tagName && textContent) {
            var rootElement = document.createElement(tagName);
            rootElement.textContent = textContent;
            if (className) {
                rootElement.classList.add(className);
            }
        }
        
        return rootElement;
    },
    createAnchorTag: function(href, linkText, className, dataName, dataValue) {
        var rootElement = null; 
        
        if (href && linkText) {
            var rootElement = document.createElement('a');
            rootElement.href = href;
            if (className) {
                rootElement.className = className;
            }
            if (dataName && dataValue) {
                rootElement.dataset[dataName] = dataValue;
            }
            rootElement.innerText = linkText;
        }
        return rootElement;
    },
    createListItem: function(element) {
        var rootElement = null;
        
        if (element) {
            rootElement = document.createElement('li');
            rootElement.appendChild(element);
        }
        
        return rootElement;
    },
    createInputTag: function(type, name, value) {
        var inputTag; 
        
        if (type, name && value) {
            inputTag = document.createElement('input');
            inputTag.type = type;
            inputTag.name = name;
            inputTag.value = value;
        }
        
        return inputTag;
    },
    addItemToElement: function(rootElement, item) {
        if (!rootElement) {
            return;
        }
        if (typeof item==='string' || typeof item==='number' || typeof item==='boolean') {
            rootElement.appendChild(document.createTextNode(item));
        } else if (item instanceof Element && item.tagName) {
            rootElement.appendChild(item)
        } else if (item instanceof Array) {
            var itemForEachHandler = function(data) {
                rootElement.appendChild(data);
            }
            item.forEach(itemForEachHandler);
        }
    },
    createNode: function (tagName, item, className) {
        var rootElement = null;
        
        if (tagName && item) {
            rootElement = document.createElement(tagName);
            if (className) {
                var names = className.split(' ');
                for (var i=0;i<names.length;i++) {
                    rootElement.classList.add(names[i]);
                }
            }
            IllumioDomUtils.addItemToElement(rootElement, item);
        }
        
        return rootElement;
    },
    createTableCell: function(item, className, isHeading) {
        var rootElement = null;
        
        if (item || (item && item.constructor===String)) {
            rootElement = (isHeading) ? document.createElement('th') : document.createElement('td');
            if (className) {
                rootElement.className = className;
            }
            IllumioDomUtils.addItemToElement(rootElement, item);
        }
        
        return rootElement;
    },
    populateSelectOptions: function(theElement, theArray, selectedItem) {
        if (theElement) {
            this.removeChildren(theElement);
            theElement.options.add(new Option('-', ''));
            var theArrayForEachHandler = function(item) {
                if (item && item.length==2) {
                    var selected = (selectedItem && item[0]===selectedItem) ? true : false;
                    theElement.appendChild(new Option(item[1], item[0], false, selected));
                } else {
                    var selected = (selectedItem && item===selectedItem) ? true : false;
                    theElement.appendChild(new Option(item, item, false, selected));

                }
            }
            theArray.forEach(theArrayForEachHandler);
        } else {    
            console.error('theElement is ' + theElement);
        }
    },
    createRadioButton:function(name, value, displayText, classNames, isChecked, callback) {
        // Create the following element:
        //     <label><input name="version" type="radio" value="17.3"> <span>17.3</span></label>
        var rootElement = null;
        
        if (value && displayText) {
            var displayTextSpanElement = document.createElement('span');
            displayTextSpanElement.innerText = displayText;
            
            var inputElement = document.createElement('input');
            inputElement.name = name;
            inputElement.type = 'radio';
            inputElement.value = value;
            inputElement.onclick = callback;
            if (classNames) {
                for (const className of classNames) {
                    inputElement.classList.add(className);
                }
            }
            inputElement.checked = isChecked;
            
            rootElement = document.createElement('label');
            rootElement.appendChild(inputElement);
            rootElement.appendChild(displayTextSpanElement);
        }
        
        return rootElement;
    },
    /**
     * Scan DOM tree and return only allowed tags and allowed attributes (for certain tag).
     */
    sanitizeDOMTree: function(node) {
        const allowedTags = [ 'div', 'p', 'b', 'i', 'u', 'strong', 'em', 'span', 'a', 'ul', 'ol', 'li', 'br' ];
        const allowedAttributes = {
            'a': [ 'class', 'href' ],
            'div': [ 'class', 'style' ],
            'i': [ 'class' ],
            'p': [ 'data-stringify-type' ],
            'span': [ 'class', 'style' ],
        };
                  
        function sanitizeNode(element) {
            console.info(`» element ${element.nodeType}:`);
            console.debug(element);
            if (element.nodeType===Node.ELEMENT_NODE) {
                if (!allowedTags.includes(element.tagName.toLowerCase())) {
                    return document.createTextNode(element.textContent);
                }
      
                const sanitizedElement = document.createElement(element.tagName);
            
                for (let attr of element.attributes) {
                    if (allowedAttributes[element.tagName.toLowerCase()]?.includes(attr.name)) {
                        if (attr.name==='href') {
                            // Sanitize URLs to prevent javascript: protocol
                            const url = attr.value.trim().toLowerCase();
                            if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) { 
                                sanitizedElement.setAttribute(attr.name, attr.value);
                            }
                        } else {
                            sanitizedElement.setAttribute(attr.name, attr.value);
                        }
                    }
                }
      
                for (let child of element.childNodes) {
                    sanitizedElement.appendChild(sanitizeNode(child));
                }

                console.debug(`IllumioDomUtils.sanitizedElement with ${element.nodeType}:`);
                console.debug(sanitizedElement);
                
                return sanitizedElement;
            } else if (element.nodeType===Node.TEXT_NODE) {
                console.debug(`IllumioDomUtils.sanitizedElement with ${element.nodeType}:`);
                console.debug(document.createTextNode(element.textContent))

                return document.createTextNode(element.textContent);
            }

            console.debug(`IllumioDomUtils.sanitizedElement with unsupported ${element.nodeType}:`);
            console.debug(document.createTextNode(''));

            return document.createTextNode('');
        }
      
        return sanitizeNode(node);
    },
    /**
     * Convert HTML string to DOM tree. It returns the tree in the body tag.
     * ASSUMPTIOM: The body tag contains only one node. If there are multiple nodes, it returns only the first child.
     */
    parseHtml: function(text, isAddingWrapper=true) {
        const parser = new DOMParser();
        const rawHtmlString = (isAddingWrapper) ? `<span>${text}</span>` : text;
        const rootElement = parser.parseFromString(rawHtmlString, 'text/html');
        if (rootElement) {
            console.debug(`IllumioDomUtils.parseHtml('${text}', ${isAddingWrapper}):`);
            console.debug(rootElement.querySelector('body > *'));
            return rootElement.querySelector('body > *');
        }
    }
}

export default IllumioDomUtils;
